import { createFileRoute, Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { IntegrationsScreen } from '../../features/integrations/integrations-screen';

export const Route = createFileRoute('/integrations/')({
  component: IntegrationsPage,
});

/** `/integrations` — the clinic's vendor connections (MASTER_PLAN M3.9, FR-ADMIN-09). */
function IntegrationsPage() {
  return (
    <IntegrationsScreen
      renderLink={(to, children, className): ReactNode => (
        <Link to={to} className={className}>
          {children}
        </Link>
      )}
    />
  );
}
